import { render, staticRenderFns } from "./visitAccessCard.vue?vue&type=template&id=1f4110b4&scoped=true"
import script from "./visitAccessCard.vue?vue&type=script&lang=js"
export * from "./visitAccessCard.vue?vue&type=script&lang=js"
import style0 from "./visitAccessCard.vue?vue&type=style&index=0&id=1f4110b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4110b4",
  null
  
)

export default component.exports